import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
import { Button } from './ui/Button';
export function SpiritualSection() {
  return <section className="relative w-full py-24 px-4 overflow-hidden" data-id="element-134">
      {/* Background Image */}
      <div className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat bg-fixed" style={{
      backgroundImage: 'url(https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=1600)'
    }} data-id="element-135" />

      {/* Light Overlay for readability */}
      <div className="absolute inset-0 z-10 bg-white/90" data-id="element-136" />

      <div className="relative z-20 max-w-5xl mx-auto" data-id="element-137">
        {/* Top Content */}
        <div className="text-center mb-16" data-id="element-138">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-139">
            CUANDO HAY AMOR VERDADERO, EXISTE UN LAZO ENERGÉTICO REAL
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed" data-id="element-140">
            Cuando dos personas se unen desde el corazón, se crea un vínculo
            espiritual. Cuando ese vínculo se daña por conflictos, terceros,
            traiciones o cargas emocionales, el amor no desaparece… se bloquea.
          </p>
          <p className="text-2xl font-bold text-rose-600 mt-6" data-id="element-141">
            Ahí es donde intervenimos.
          </p>
        </div>

        {/* Stats Card */}
        <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12 border border-rose-100" data-id="element-142">
          <div className="text-center mb-10" data-id="element-143">
            <h3 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-2" data-id="element-144">
              MÁS DE 15.000 CASOS ATENDIDOS
            </h3>
            <p className="text-lg text-gray-500 font-medium" data-id="element-145">
              🌎 Presencia en Estados Unidos desde 1945
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-146">
            <div className="space-y-6" data-id="element-147">
              <p className="text-lg text-gray-700 font-medium" data-id="element-148">
                Durante décadas hemos acompañado a personas que:
              </p>
              <ul className="space-y-4" data-id="element-149">
                {['Perdieron a su pareja de forma inesperada', 'Vivieron traiciones, distanciamientos o rupturas dolorosas', 'Buscaban recuperar, atraer o fortalecer un vínculo amoroso'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-150">
                    <div className="w-2 h-2 bg-rose-500 rounded-full mt-2.5 flex-shrink-0" data-id="element-151" />
                    <span className="text-gray-600 text-lg" data-id="element-152">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div className="bg-rose-50 p-6 rounded-2xl border border-rose-100" data-id="element-153">
              <p className="text-gray-700 italic mb-6" data-id="element-154">
                "Nuestro Maestro Espiritual Mayor, reconocido
                internacionalmente, trabaja con técnicas ancestrales de sanación
                y armonización, transmitidas de generación en generación."
              </p>

              <div className="space-y-3" data-id="element-155">
                <div className="flex items-center gap-2 text-red-500 font-medium" data-id="element-156">
                  <XCircle className="w-5 h-5" data-id="element-157" />
                  <span data-id="element-158">No es improvisación</span>
                </div>
                <div className="flex items-center gap-2 text-red-500 font-medium" data-id="element-159">
                  <XCircle className="w-5 h-5" data-id="element-160" />
                  <span data-id="element-161">No es magia superficial</span>
                </div>
                <div className="flex items-center gap-2 text-green-600 font-bold text-lg" data-id="element-162">
                  <CheckCircle2 className="w-6 h-6" data-id="element-163" />
                  <span data-id="element-164">
                    Es conocimiento espiritual aplicado con ética y respeto
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="text-center mt-12 pt-10 border-t border-rose-100" data-id="element-165">
            <p className="text-lg text-gray-600 mb-6" data-id="element-166">
              ¿Quieres ser el próximo caso de éxito?
            </p>
            <a href="https://wa.me/13052196902" target="_blank" rel="noopener noreferrer" className="inline-block" data-id="element-167">
              <Button size="large" className="text-lg px-10 py-6 bg-rose-600 hover:bg-rose-700 text-white border-none font-bold shadow-[0_0_20px_rgba(225,29,72,0.4)] transition-all hover:scale-105" data-id="element-168">
                QUIERO MI CONSULTA AHORA
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>;
}